import ScrewData from '../data/screws-data.js';
import TableComponent from '../TableComponent.js';
import './DrillsPage.css';

const ScrewsPage = () => {
  return (
    <>
      <section className="content-wrap">
        <h2>Screw & Tap Drill Table</h2>
        <p>For educational purposes only.</p>
        <div id="table-div">
          <TableComponent data={ScrewData} />
        </div>
      </section>
    </>
  );
};

export default ScrewsPage;
